/**
 * Назви організацій для колонки «Організація» у списках документів
 * (рішення власника 2026-08-26: Продажі/Закупки/Склад — усі списки).
 */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ColDef } from 'ag-grid-community';
import { orgs } from '@/api/catalogs';
import type { ColumnDef } from '@/shared/components/DataTable';

export function useOrgNames(): Map<string, string> {
  const q = useQuery({ queryKey: ['orgs'], queryFn: () => orgs.list({ limit: 200 }) });
  return useMemo(() => {
    const m = new Map<string, string>();
    q.data?.items.forEach((o) => m.set(o.id, o.name));
    return m;
  }, [q.data]);
}

/** ag-Grid колонка «Організація» (вставляти після дати документа). */
export function agOrgCol<T extends { organization_id?: string }>(
  names: Map<string, string>,
): ColDef<T> {
  return {
    field: 'organization_id' as ColDef<T>['field'], headerName: 'Організація',
    // Сортування СЕРВЕРНЕ за назвою організації (org_name_sq у whitelist'ах
    // цільових списків — аудит 2026-08-26).
    width: 190, sortable: true,
    valueFormatter: (p) => (p.value ? names.get(p.value as string) ?? '' : ''),
  };
}

/** DataTable-колонка «Організація» (вставляти після дати документа). */
export function dtOrgCol<T extends { organization_id?: string }>(
  names: Map<string, string>,
): ColumnDef<T> {
  return {
    key: 'organization',
    header: 'Організація',
    width: 190,
    sortValue: (r) => (r.organization_id ? names.get(r.organization_id) ?? '' : ''),
    cell: (r) => (r.organization_id ? names.get(r.organization_id) ?? '' : ''),
  };
}
